/**
 * 認証関連のイベントリスナー
 * 認証システムのイベント処理を管理
 */

import { AUTH_EVENTS } from '@/lib/events/constants';
import { addEventListener } from '@/lib/events/helpers';
import { navigateToUrl } from '@/utils/navigateToUrl';

/**
 * 認証関連のイベントリスナーを初期化
 */
export const initializeAuthEventListeners = () => {
  // Auth関連イベントリスナー
  // 静的 import は循環参照になるため動的 import で logout を取得する。
  const handleAuthLogout = () => {
    import('@/lib/auth').then(({
      logout
    }) => logout());
  };
  const handleAuthUnauthorized = () => {
    import('@/lib/auth').then(({
      logout
    }) => logout());
  };
  const handleAuthRefreshSession = () => {
    // セッションリフレッシュ処理
    import('@/lib/auth').then(({
      useAuthStore
    }) => {
      const authStore = useAuthStore.getState();
      authStore.refreshUserSession();
    });
  };
  let isNavigatingToMe = false;
  const handleNoOrganizationAccess = () => {
    if (isNavigatingToMe) return;
    isNavigatingToMe = true;
    navigateToUrl('/me');
  };

  // イベントリスナーを登録
  addEventListener(AUTH_EVENTS.LOGOUT, handleAuthLogout);
  addEventListener(AUTH_EVENTS.UNAUTHORIZED, handleAuthUnauthorized);
  addEventListener(AUTH_EVENTS.REFRESH_SESSION, handleAuthRefreshSession);
  addEventListener(AUTH_EVENTS.NO_ORGANIZATION_ACCESS, handleNoOrganizationAccess);
};